import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewProductAction,
  showAddProductDivAction,
} from "../redux/actions/productsActions";
import * as LocalStorage from "../../utils/localStorage";
import { FaTimes } from "react-icons/fa";
import uploadImg from "../../utils/upload.webp";
import styles from "./productsStyles.module.css";
const AddNewProduct = () => {
  const actionDispatch = useDispatch();
  const { data: productsData, showAddProductComponent } = useSelector(
    (state) => state.products
  );
  const closeAddProduct = () => {
    if (showAddProductComponent) {
      actionDispatch(showAddProductDivAction(false));
    }
  };
  const AddNewProductToList = (event) => {
    event.preventDefault();
    const productsArray = productsData.products;
    const {
      name,
      expiryDate,
      categories,
      productDescription,
      stock,
      unitsSold,
    } = event.target;
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let newExpiryDate = expiryDate.value.split("-");
    newExpiryDate.splice(1, 1, monthNames[Number(newExpiryDate[1]) - 1]);
    newExpiryDate.reverse();
    newExpiryDate = newExpiryDate.join(" ");
    if((/^[1-9]\d*$/.test(unitsSold.value)) && (/^[1-9]\d*$/.test(stock.value))){
      const newProduct = {
        category: categories.value,
        description: productDescription.value,
        expireDate: newExpiryDate,
        name: name.value,
        stock: stock.value,
        unitSold: unitsSold.value,
      };
      productsArray.push(newProduct);
      LocalStorage.setLSValue("productsData", {
        ...productsData,
        products: productsArray,
      });
      actionDispatch(
        addNewProductAction(LocalStorage.getLSValue("productsData"))
      );
      if (showAddProductComponent) {
        actionDispatch(showAddProductDivAction(false));
      }
      alert("product added successfully")
    }
    else if(!(/^[1-9]\d*$/.test(unitsSold.value))){
      alert("Please enter valid number of units sold.")
    }
    else if(!(/^[1-9]\d*$/.test(stock.value))){
      alert("Please enter valid number of stock.")
    }
  };
  return (
    <div className={styles.newProductDiv}>
      <h1 className={styles.newProductHeading}>Add Product</h1>
      <button className={styles.closeAddProduct} onClick={closeAddProduct}>
        <FaTimes />
      </button>
      <div className={styles.addProduct}>
        <form onSubmit={(event) => AddNewProductToList(event)} id={styles.addProductForm}>
          <label htmlFor={styles.productName}>product Name</label>
          <input id={styles.productName} name="name" type="text" placeholder="please enter valid product name" required></input>
          <label htmlFor={styles.productDescription}>Description</label>
          <textarea
            name="productDescription"
            id={styles.productDescription}
            placeholder="please enter valid product description"
            required
          ></textarea>
          <label
            htmlFor={styles.selectCategory}
            className={styles.categoriesForNew}
          >
            Categories
          </label>
          <select name="categories" id={styles.selectCategory} required>
            <option key="select category" value="">
              Select Category
            </option>
            {productsData.categories.map((category) => {
              return (
                <option key={category} value={category}>
                  {category}
                </option>
              );
            })}
          </select>
          <label htmlFor={styles.newExpireDate}>Expire Date</label>
          <input
            id={styles.newExpireDate}
            name="expiryDate"
            type="date"
            required
          ></input>
          <label htmlFor={styles.unitsSold}>Units Sold</label>
          <input id={styles.unitsSold} name="unitsSold" type="text" placeholder="please enter valid number of units sold" required></input>
          <label htmlFor={styles.newStock}>Units In Stock</label>
          <input id={styles.newStock} name="stock" type="text" placeholder="please enter valid stock" required></input>
          <button className={styles.productPageButtons+" "+styles.addProductBtn} type="submit">Add product Now</button>
        </form>
        <div className={styles.newProductImgDiv}>
          <img
            className={styles.newProductImg}
            src={uploadImg}
            alt="upload"
          ></img>
          <h2 className={styles.uploadProductImage}>Upload image</h2>
        </div>
      </div>
    </div>
  );
};

export default AddNewProduct;
